import { api } from "@/lib/axios";

export default function createNote(leadId: string, text: string, type: string) {
  return api.post(`notes/${leadId}`, {
    text,
    type,
  });
}
